<template>
  <div class="content">
    <a-scroll-table class="table"
                    :columns="FUND_DETAILS_COLUMNS"
                    :data-source="dataSource"
                    :pagination="false">
    </a-scroll-table>
    <div class="footer">
      <APagination v-model:current="pagination.current"
                   v-model:pageSize="pagination.pageSize"
                   :show-size-changer="true"
                   :total="pagination.total"
                   @change="handleTableChange" />
    </div>
  </div>
</template>

<script setup lang="ts">
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  AXIOSKEY
} from '@/core'
import { AScrollTable, APagination } from '@iota-cn/ui-components'
import type { TableColumnsType } from 'ant-design-vue'
import dayjs from 'dayjs'
import { computed, inject, onMounted, ref } from 'vue'
import { useI18n } from "vue-i18n"

const { t } = useI18n()

interface DataSource {
  id: number,
  out_trade_number: number,
  amount: number,
  time: number
}
const dataSource = ref<DataSource[]>([])
const axios = inject(AXIOSKEY)

const FUND_DETAILS_COLUMNS = computed<TableColumnsType>(() => [
  {
    title: t('financial.FinancialBills.tradeNumber'),
    dataIndex: 'out_trade_number',
    ellipsis: true,
  },
  {
    title: t('financial.FinancialBills.time'),
    dataIndex: 'time',
    ellipsis: true,
  },
  {
    title: t('financial.FinancialBills.amount'),
    dataIndex: 'amount',
    ellipsis: true,
    customCell: (record, rowIndex) => {
      return {
        style: {
          "color": '#ffc20e'
        }
      }
    }
  }
])

const pagination = ref({
  current: 1,
  total: 0,
  offset: 0,
  pageSize: 20,
  showSizeChanger: true,
  pageSizeOptions: ['20', '40', '60', '80'], // 每页中显示的数据
  showTotal: (total: number) => `${t('financial.FinancialBills.total')} ${total} ${t('financial.FinancialBills.strip')}`, // 分页中显示总的数据
  size: 'small',
})

onMounted(() => {
  getBmsBill()
})

const getBmsBill = async () => {
  await axios?.get(`/v1/api/bms/bill?limit=${pagination.value.pageSize}&offset=${pagination.value.offset}`).then((res: any) => {
    convert(res)
    dataSource.value = res.bill
  })
}

const convert = (res: any) => {
  res.bill.forEach((r: any) => {
    r.time = dayjs(r.createdAt).format('YYYY-MM-DD')
    r.amount = '￥' + r.amount
  })
  pagination.value.total = res.total
}


const handleTableChange = (current: number, pageSize: number) => {
  pagination.value.current = current
  pagination.value.offset = (current - 1) * pageSize
  getBmsBill()
}

</script>
<style lang="less" scoped>
.content {
  width: 100%;
  height: 100%;
  padding: 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;

  .table {
    flex: 1;
    margin-top: 20px;
    overflow: hidden;
  }

  .footer {
    display: flex;
    justify-content: end;
  }
}
</style>
